import React, { memo, useCallback } from "react";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

import styles from "./styles.module.scss";
import { TStore } from "models";
import { ChangeCommunityMenu, GroupSection } from "./components";
import { GetImg, whitelistSrc } from "utils";

const stateSelectorHandle = createSelector(
	(state: TStore) => state.community,
	(state: TStore) => state.app.siderMenu.showJoinedCommuntiesList,
	(state: TStore) => state.app.currentGroupId,
	(state: TStore) => state.app.siderMenu.collapsed,
	(
		community,
		siderMenuShowJoinedCommuntiesList,
		currentGroupId,
		siderMenuCollapsed,
	) => ({
		community,
		siderMenuShowJoinedCommuntiesList,
		currentGroupId,
		siderMenuCollapsed,
	}),
);

interface ISiderTopInfo {
	handleTriggerTheDrawerMenu: () => void;
}

const SiderTopInfo: React.FunctionComponent<ISiderTopInfo> = ({
	handleTriggerTheDrawerMenu,
}) => {
	const stateSelector = useCallback(stateSelectorHandle, []);
	const {
		community,
		siderMenuShowJoinedCommuntiesList,
		currentGroupId,
		siderMenuCollapsed,
	}: any = useSelector(stateSelector);

	return (
		<div className={styles.siderTopInfo}>
			{currentGroupId ? (
				<GroupSection />
			) : (
				<div className={styles.communitySection}>
					<ChangeCommunityMenu
						handleTriggerTheDrawerMenu={handleTriggerTheDrawerMenu}
					/>
					{siderMenuCollapsed && (
						<div
							style={{
								position: "absolute",
								right: 8,
								top: 6,
								color: "#fff",
								cursor: "pointer",
							}}
							onClick={handleTriggerTheDrawerMenu}
						>
							{
								<ArrowLeftOutlined
									style={{
										fontFamily: `"Avenir Heavy", sans-serif`,
									}}
								/>
							}
						</div>
					)}
					{!siderMenuShowJoinedCommuntiesList && (
						<>
							<div className={styles.logoSection}>
								<Link to="/" className={styles.logo}>
									{whitelistSrc.indexOf(
										community.data &&
											community.data.picture,
									) === -1 ? (
										<GetImg
											endpoint={
												community.data &&
												community.data.picture
											}
										/>
									) : (
										<img
											src={
												community.data &&
												community.data.picture
											}
											alt=""
										/>
									)}
								</Link>
							</div>
						</>
					)}
				</div>
			)}
		</div>
	);
};

export default memo(SiderTopInfo);
